export const PUBLIC_DOMAIN_CATEGORIES = [
  'Top Provider',
  'Education (.edu)',
  'Business / Shared',
  'Privacy-Focused',
  'Other',
] as const

export type PublicDomainCategory = (typeof PUBLIC_DOMAIN_CATEGORIES)[number]

// Curated map for recognizable providers only; the backend blacklist is a flat
// uncategorized list of ~4,800 domains, so everything unmapped falls into
// "Other" — expected to dominate the counts.
const TOP_PROVIDERS = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'ymail.com',
  'rocketmail.com',
  'outlook.com',
  'hotmail.com',
  'hotmail.co.uk',
  'live.com',
  'msn.com',
  'icloud.com',
  'me.com',
  'mac.com',
])

// Matched, not listed: this file only sees domains already on the backend blacklist.
const AOL_FAMILY = /^aol\.[a-z]{2,3}(\.[a-z]{2,3})?$/

// AOL's consumer aliases carry no `aol.` prefix, so the pattern above can't reach them.
const AOL_ALIASES = new Set(['aim.com', 'cs.com', 'netscape.net', 'wmconnect.com', 'wow.com', 'ygm.com'])

const PRIVACY_FOCUSED = new Set([
  'protonmail.com',
  'protonmail.ch',
  'proton.me',
  'pm.me',
  'tutanota.com',
  'tutanota.de',
  'tutamail.com',
  'tuta.io',
  'tuta.com',
  'keemail.me',
  'hushmail.com',
  'mailfence.com',
  'posteo.de',
  'posteo.net',
  'startmail.com',
])

const BUSINESS_SHARED = new Set([
  'zoho.com',
  'zohomail.com',
  'fastmail.com',
  'fastmail.fm',
  'gmx.com',
  'gmx.de',
  'gmx.net',
  'mail.com',
  'yandex.com',
  'yandex.ru',
  'web.de',
  't-online.de',
  'mail.ru',
])

export function categorizeDomain(domain: string): PublicDomainCategory {
  if (TOP_PROVIDERS.has(domain) || AOL_FAMILY.test(domain) || AOL_ALIASES.has(domain)) return 'Top Provider'
  if (PRIVACY_FOCUSED.has(domain)) return 'Privacy-Focused'
  if (BUSINESS_SHARED.has(domain)) return 'Business / Shared'
  if (domain.endsWith('.edu')) return 'Education (.edu)'
  return 'Other'
}
